export const FALLBACK_IMAGE_CARD =
  "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=900&q=80";

export const FALLBACK_IMAGE_HERO =
  "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?auto=format&fit=crop&w=1200&q=80";

export function upscaleArtwork(url, size = "t500x500") {
  if (!url || typeof url !== "string") return "";
  return url.replace(/-large\./, `-${size}.`);
}

export function asString(value, fallback = "") {
  if (value === undefined || value === null) return fallback;
  return String(value);
}

export function asNumber(value, fallback = 0) {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function asBoolean(value, fallback = false) {
  if (typeof value === "boolean") return value;
  if (value === undefined || value === null) return fallback;
  return Boolean(value);
}

export function formatDuration(durationMs) {
  const totalSeconds = Math.max(0, Math.floor((Number(durationMs) || 0) / 1000));
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${String(seconds).padStart(2, "0")}`;
}

export function formatCount(value) {
  const count = Number(value) || 0;
  if (count >= 1_000_000) return `${(count / 1_000_000).toFixed(1)}M`;
  if (count >= 1_000) return `${(count / 1_000).toFixed(1)}K`;
  return String(count);
}

export function formatPlays(playbackCount) {
  return formatCount(playbackCount);
}

export function resolveArtistName(track) {
  return (
    track?.user?.username ||
    track?.publisher_metadata?.artist ||
    track?.user?.permalink ||
    "Unknown Artist"
  );
}

export function resolveUserAvatar(user) {
  return upscaleArtwork(user?.avatar_url, "t500x500") || FALLBACK_IMAGE_CARD;
}

export function buildTrackAvailability(track) {
  const transcodings = Array.isArray(track?.media?.transcodings) ? track.media.transcodings : [];
  const hasTranscodings = transcodings.length > 0;
  const allSnipped = hasTranscodings && transcodings.every((item) => Boolean(item?.snipped));
  const policy = String(track?.policy || "").toLowerCase();
  const policyRestricted = policy.includes("snip") || policy.includes("blocked");
  const isUnavailable = allSnipped || (policyRestricted && hasTranscodings);

  return {
    isUnavailable,
    unavailableText: isUnavailable ? "Not available in your country" : "",
  };
}
